var React = require('react');

function HomeIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Home"),React.createElement("g",{"key":1},React.createElement("path",{"className":"house-shape","d":"M33.79,17L17.98,1.69c-0.27-0.26-0.68-0.26-0.95,0L1.21,17c-0.2,0.2-0.27,0.5-0.16,0.76\n\t\tc0.1,0.26,0.36,0.44,0.64,0.44h3.44V32.8c0,0.38,0.31,0.7,0.69,0.7h8.25c0.38,0,0.69-0.31,0.69-0.7v-7.65h5.5v7.65\n\t\tc0,0.38,0.31,0.7,0.69,0.7h8.25c0.38,0,0.69-0.31,0.69-0.7V18.2h3.44c0.28,0,0.53-0.17,0.64-0.44C34.06,17.5,33.99,17.19,33.79,17z\n\t\t"}))]);
}

HomeIcon.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"26","height":"26","viewBox":"0 0 35 35","style":{"enableBackground":"new 0 0 35 35"},"xmlSpace":"preserve"};

module.exports = HomeIcon;

HomeIcon.default = HomeIcon;
